import { LoadingButtonProps } from '@mui/lab';
import { StyledLoadingButton, LoadingIcon } from './styles';

interface ILoadingButton extends LoadingButtonProps {
  $maxWidth?: string;
}

export const LoadingButton = ({ children, $maxWidth, ...props }: ILoadingButton) => {
  return (
    <StyledLoadingButton
      $maxWidth={$maxWidth}
      variant="contained"
      loadingIndicator={<LoadingIcon sx={{ color: '#FFF' }} />}
      {...props}
    >
      {children}
    </StyledLoadingButton>
  );
};
